import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-copy",
  "use": "icon-copy-usage",
  "viewBox": "0 0 12.5 12.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 12.5 12.5\" id=\"icon-copy\"><g><g><path d=\"M10,2.5L12.5,2.5L12.5,12.5L2.5,12.5L2.5,10L0,10L0,0L10,0L10,2.5ZM10,3.33333L10,10L3.33333,10L3.33333,11.6667L11.6667,11.6667L11.6667,3.33333L10,3.33333ZM0.833333,0.833333L0.833333,9.16667L9.16667,9.16667L9.16667,0.833333L0.833333,0.833333Z\" fill=\"#C7F5F5\" fill-opacity=\"1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol